var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#6D7270",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.711 5h-7.893A5.824 5.824 0 005 10.818v7.893a5.824 5.824 0 005.818 5.818h7.893a5.824 5.824 0 005.818-5.818v-7.893A5.824 5.824 0 0018.71 5zm3.853 13.711a3.853 3.853 0 01-3.853 3.853h-7.893a3.853 3.853 0 01-3.853-3.853v-7.893a3.853 3.853 0 013.853-3.853h7.893a3.853 3.853 0 013.853 3.853v7.893z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.614 9.507a5.113 5.113 0 00-5.107 5.107 5.113 5.113 0 005.107 5.108 5.113 5.113 0 005.108-5.108 5.113 5.113 0 00-5.108-5.107zm0 8.228a3.12 3.12 0 110-6.242 3.12 3.12 0 010 6.242z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.722,
    cy: 9.807,
    r: 1.202
  }))));
}
export default SvgInstagram;